import { ELEMENT_INFO } from '@nine/shared';
import { drop, moon, peak, star, taiji } from '../kit';
import { C } from '../pix';
import { defineIconKind, registerIcons } from '../store';

/** Elements (ธาตุ): a round medallion in the element's colour with its sign. */

defineIconKind('element', {
  label: 'ธาตุ',
  ids: () => Object.keys(ELEMENT_INFO),
  name: (id) => ELEMENT_INFO[id as keyof typeof ELEMENT_INFO]?.name ?? id,
  tint: (id) => ELEMENT_INFO[id as keyof typeof ELEMENT_INFO]?.color ?? C.gold,
  plate: 'round',
  fallback: () => ({ draw: (p) => star(p, 16, 16, 6) }),
});

registerIcons('element', {
  yin: (p) => {
    moon(p, 16, 16, 10, '#e8d8ff');
    star(p, 23, 9, 2, C.white);
  },
  soft: (p) => {
    drop(p, 16, 19, 7, '#7ad8f0');
    for (let x = 5; x < 28; x++) p.px(x, 27 + Math.round(Math.sin(x / 2)), '#bfeaff');
  },
  taiji: (p) => taiji(p, 16, 16, 10),
  yang: (p) => {
    for (let k = 0; k < 8; k++) {
      const a = (k * Math.PI) / 4;
      p.line(
        16 + Math.cos(a) * 9,
        16 + Math.sin(a) * 9,
        16 + Math.cos(a) * 12,
        16 + Math.sin(a) * 12,
        '#ffe07a',
      );
    }
    p.ell(16, 16, 7, 7, '#ffd040');
  },
  hard: (p) => {
    peak(p, 16, 26, 22, 18, '#c89060', '#f0d0a0');
    p.rect(5, 25, 22, 2, '#8a5a3a');
  },
});
